module.exports = __webpack_public_path__ + "static/media/evaImage.3ea92df4.png";